import { CommonType } from "./common.type";

export interface Ranking {
  userId: number;
  thumbnail: string;
  fullName: string;
  totalUser: number;
  totalMoney: number;
  isOwner: boolean;
}

export interface RankingResponse {
  items: Ranking[];
  myRanking: Ranking;
  totalUser: number;
  currentRanking: number;
}

export interface CreateTransferPayload {
  bankName: string;
  bankNumber: string;
  bankOwner: string;
  amount: number;
}

export interface TransferHistory extends CommonType {
  id: number;
  createdDate: number;
  amount: number;
  remainingAmount: number;
  bankNumber: string;
  bankName: string;
  bankOwner: string;
  expiredDate: number;
  status: TransferStatus;
  errorMessage: string | null;
}

export enum TransferStatus {
  SUCCESS = 1,
  PROCESSING = 2,
  TIMEOUT = 3,
  ERROR = 4,
}
